import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

const getClubCartLine = (urls: any, domain: string, deviceCode: string, cartUid: string, lineUid: string) => {
	const params = new URLSearchParams({cartUid, lineUid})
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/carts/clubline?${params.toString()}`);
}

// clubLine is undefined until loaded, then the cart line or null when the cart has no such line.
export default function useGetClubCartLine(urls: any, domain: string, deviceCode: string, cartUid: string, lineUid: string) {
	const {status, data, error} = useQuery(['ClubCartLine', cartUid, lineUid], () => getClubCartLine(mapServiceUrls(urls), domain, deviceCode, cartUid, lineUid), { enabled: urls && !!cartUid && !!lineUid, staleTime: 1000*60*60 });
	const clubLine = data ? data.data?.Line ?? null : undefined;
	return {lineStatus: status, clubLine, lineError: error};
}
